import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ProgressModel} from 'src/app/services/models/progress.model';
import {UserInfoModel} from 'src/app/services/models/user-info.model';

@Component({
    selector: 'app-delegate-home',
    templateUrl: './delegate-home.component.html',
    styleUrls: ['./delegate-home.component.scss']
})
export class DelegateHomeComponent implements OnInit {
    environment = null;
    menuVisible = true;

    @Input() userInfo: UserInfoModel = null;
    @Input() progress: ProgressModel = null;

    constructor(
        private router: Router,
    ) {
    }

    ngOnInit() {
    }

    goToJourney() {
        if (this.userInfo.stages.active.length > 0) {
            this.router.navigate(['/journey', this.userInfo.stages.active[0]]);
        }
    }
}
